/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { Formik } from "formik";
import { AlertStatus } from "../../../../../contants";
import styles from "./styles";
import InputField from "../../../../../components/common/new/InputField/InputField";
import Typography from "../../../../../components/common/new/Typography/Typography";
import Button from "../../../../../components/common/Button";
import { CommonStyles } from "../../../../../components/common/Button/commonButtonStyle";
import { ToastAlertContext } from "../../../../../config/providers/ToastAlert";
import Examination from "../../../../../services/api/examination";

export const FIELDS = {
  REASON: "reason",
  RETAIN_MEMBER_ID: "retainMemberId",
  REMARKS: "remark",
};

const REMARK = "remark";

function DeactivateModal({ onClose, callBack, selectedMember }) {
  const toast = useContext(ToastAlertContext);
  const [remark, setRemark] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === REMARK) {
      setRemark(value);
    }
  };

  const validateFormData = () => {
    if (!remark) {
      return "Please enter remark";
    }
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const error = validateFormData();
      if (error) throw new Error(error);

      const body = {
        remark,
      };
      await Examination.deactivateAppliedMember({
        data: body,
        applicationId: selectedMember?.id,
      });

      toast.show("Member Deactivated successfully", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
        callBack();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Formik initialValues={{}}>
      {({ values }) => (
        <form onSubmit={onSubmit}>
          {/* {(isActive || isDeactivated) && ( */}
          <Box sx={{ marginBottom: "20px" }}>
            <Typography fontWeight={500}>Deactivate Member</Typography>
          </Box>
          <Box>
            <InputField
              name={REMARK}
              variant="outlined"
              label="Enter your remark"
              style={styles.inputStyle}
              value={values[FIELDS.REMARKS]}
              onChange={handleInputChange}
              InputProps={{ sx: { minHeight: "91px" } }}
              required
            />
          </Box>
          <div style={{ display: "flex", gap: 20 }}>
            <Button
              variant="contained"
              style={CommonStyles.buttonStyle}
              onClick={onSubmit}
              type="submit"
              label="Deactivate"
            />
            <Button
              style={CommonStyles.buttonStyle}
              variant="outlined"
              onClick={onClose}
              label="Cancel"
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default DeactivateModal;
